import {
  actionCloseSelectActivity,
  actionOpenSelectActivity,
} from 'lib/actions';
import {
  getSelectActivityOpen,
  getSelectActivityOptions,
} from 'lib/selectors/getSelectActivity';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const useSelectActivity = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const selectActivityOpen = useSelector(getSelectActivityOpen);
  const selectActivityOptions = useSelector(getSelectActivityOptions);

  const openSelectActivity = useCallback(
    (options = {}) => {
      return dispatch(
        actionOpenSelectActivity({
          ...options,
        })
      );
    },
    [dispatch]
  );

  const closeSelectActivity = useCallback(
    (redirectPath) => {
      const path = redirectPath || selectActivityOptions?.redirectPath;

      if (path) {
        history.push(path);
      }

      return dispatch(actionCloseSelectActivity());
    },
    [dispatch, history, selectActivityOptions]
  );

  return {
    selectActivityOpen,
    selectActivityOptions,
    openSelectActivity,
    closeSelectActivity,
  };
};

export default useSelectActivity;
